import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedRoomTags from './viewRelatedRoomTags';

export default {
  title: 'Oculus Quest Images',
  attributeName: 'sportsRoom',
  fields: [
    {
      attributeName: 'xxl',
      type: FormInputTypes.DOWNLOADABLE,
      aspectRatio: '1:1',
      allowedSizes: [
        { width: 1120, height: 1120 }
      ],
      hasSelect:false,
      label: 'XXL Poster - 1120x1120',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      errorResolution: 'Older Image Resolution',
    },
    {
      attributeName: 'xlVertical',
      type: FormInputTypes.DOWNLOADABLE,
      // aspectRatio: '544:1120',
      allowedSizes: [
        { width: 544, height: 1120 }
      ],
      hasSelect:false,
      label: 'XL Vertical Poster - 544x1120',
      errorResolution: 'Older Image Resolution',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
    },
    {
      attributeName: 'xlHorizontal',
      type: FormInputTypes.DOWNLOADABLE,
      // aspectRatio: '1120:544',
      allowedSizes: [
        { width: 1120, height: 544 }
      ],
      hasSelect:false,
      label: 'XL Horizontal Poster - 1120x544',
      errorResolution: 'Older Image Resolution',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
    },
    {
      attributeName: 'lVertical',
      type: FormInputTypes.DOWNLOADABLE,
      // aspectRatio: '544:832',
      allowedSizes: [
        { width: 544, height: 832 }
      ],
      hasSelect:false,
      label: 'L Vertical Poster - 544x832',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      errorResolution: 'Older Image Resolution',
    },
    {
      attributeName: 'lHorizontal',
      type: FormInputTypes.DOWNLOADABLE,
      // aspectRatio: '832:544',
      allowedSizes: [
        { width: 832, height: 544 }
      ],
      hasSelect:false,
      label: 'L Horizontal Poster - 832x544',
      errorResolution: 'Older Image Resolution',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
    },
    {
      attributeName: 'm',
      type: FormInputTypes.DOWNLOADABLE,
      // aspectRatio: '1:1',
      allowedSizes: [
        { width: 544, height: 544 }
      ],
      hasSelect:false,
      label: 'M Poster - 544x544',
      errorResolution: 'Older Image Resolution',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
    },
    {
      attributeName: 'sVertical',
      type: FormInputTypes.DOWNLOADABLE,
      // aspectRatio: '256:544',
      allowedSizes: [
        { width: 256, height: 544 }
      ],
      hasSelect:false,
      label: 'S Vertical Poster - 256x544',
      errorResolution: 'Older Image Resolution',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
    },
    {
      attributeName: 'sHorizontal',
      type: FormInputTypes.DOWNLOADABLE,
      // aspectRatio: '544:256',
      allowedSizes: [
        { width: 544, height: 256 }
      ],
      hasSelect:false,
      label: 'S Horizontal Poster - 544x256',
      errorResolution: 'Older Image Resolution',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
    },
    {
      attributeName: 'xs',
      type: FormInputTypes.DOWNLOADABLE,
      // aspectRatio: '1:1',
      allowedSizes: [
        { width: 256, height: 256 }
      ],
      hasSelect:false,
      label: 'XS Poster - 256x256',
      errorResolution: 'Older Image Resolution',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
    },
  ],
};
